import { createRoute, redirect } from "@tanstack/react-router";
import posthog from "posthog-js";

import { isDemoEnterprise } from "../../utils/auth";
import {
  defaultPostAuthLandingKind,
  defaultPostAuthLandingPath,
} from "../../utils/defaultPostAuthLanding";
import { askPunttRoute } from "../ask-puntt/route";
import { authLayoutRoute } from "../auth-layout/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    // Demo tenants land on the Ask Puntt landing screen (Killer Demo
    // Flow Step 1) — the seeded "your 3 assets" panel + scripted
    // baseline responses live there. The legacy /home route stays
    // reachable for anyone who navigates to it directly, but `/` no
    // longer auto-routes demo users to it.
    if (isDemoEnterprise()) {
      posthog.capture("post_auth_default_landing", {
        site: "index_route",
        target: "ask-puntt",
        demo: true,
      });
      throw redirect({ to: askPunttRoute.to });
    }
    // `authLayoutRoute.loader` primes `enterprises` and `brand-guidelines`
    // before this beforeLoad runs (see auth-layout/route.tsx:55-70), so
    // the sync helper is safe here.
    const target = defaultPostAuthLandingPath();
    posthog.capture("post_auth_default_landing", {
      site: "index_route",
      target: defaultPostAuthLandingKind(),
      demo: false,
    });
    throw redirect({ to: target });
  },
});
